export default __webpack_public_path__ + "static/media/PSLOGO.90bf6029.png";